module.exports = __webpack_public_path__ + "static/media/9-0-redcube.9af8ae39.png";